module.exports = __webpack_public_path__ + "static/media/t2.7ab3289a.png";